import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import VueSocketIO from "vue-socket.io-extended";
import socketInstance from "./socketInstance";
import { AuthService } from "../services";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    sidebarShow: "responsive",
    sidebarMinimize: false,
    count: 0,
    logado: false,
    token: null,
    user: {
      id: "",
      nome: "",
      tipo: "",
      foto_perfil: "",
      desativado: "",
      notifica_solicitacao: ""
    },
    funcionario: {
      id_funcionario: null,
      parceiro_id_fk: null,
      usuario_id_fk: null,
      solicitacao: false
    }
  },
  mutations: {
    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : "responsive";
    },
    toggleSidebarMobile(state) {
      const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : "responsive";
    },
    set(state, [variable, value]) {
      state[variable] = value;
    },
    increment(state) {
      state.count++;
    },
    SET_LOGADO(state, loginState) {
      state.logado = loginState;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_NOTIFICASOL(state, payload) {
      state.user.notifica_solicitacao = payload;
    },
    SET_DESATIVADO(state, payload) {
      state.user.desativado = payload;
    },
    SET_FOTO(state, payload) {
      state.user.foto_perfil = payload;
    },
    DESTROY_USER(state) {
      state.logado = false;
      state.token = null;
      state.user.nome = "";
      state.user.tipo = "";
      state.user.id = "";
      state.user.desativado = "";
      state.user.foto_perfil = "";
      state.user.notifica_solicitacao = "";
      state.user.usuario = null;
      state.user.id_parceiro = null;
      state.funcionario.id_funcionario = null;
      state.funcionario.parceiro_id_fk = null;
      state.funcionario.usuario_id_fk = null;
      state.funcionario.solicitacao = false;
    },
    SET_USER(state, payload) {
      state.user.nome = payload.nome;
      state.user.id = payload.id;
      state.user.tipo = payload.tipo_usuario_idTipo;
      state.user.desativado = payload.desativado;
      state.user.foto_perfil = payload.foto_perfil;
      state.user.notifica_solicitacao = payload.notifica_solicitacao;
      state.user.usuario = payload.usuario;
      state.user.id_parceiro = payload.id_parceiro;
      state.funcionario.id_funcionario =
        payload.funcionario == null ? null : payload.funcionario.id_funcionario;
      state.funcionario.parceiro_id_fk =
        payload.funcionario == null ? null : payload.funcionario.parceiro_id_fk;
      state.funcionario.usuario_id_fk =
        payload.funcionario == null ? null : payload.funcionario.usuario_id_fk;
      state.funcionario.solicitacao =
        payload.funcionario == null ? false : payload.funcionario.solicitacao;
    }
  },
  actions: {
    getUserAPI(context, token) {
      Vue.use(VueSocketIO, socketInstance({ token }), {
        store, // vuex store instance
        actionPrefix: "SOCKET_", // keep prefix in uppercase
        eventToActionTransformer: actionName => actionName // cancel camel case
      });

      new Promise(async (resolve, reject) => {
        const res = await AuthService.getUserInfoByToken(token);
        switch (await res.status) {
          case 200: {
            const { data } = res;
            context.commit("SET_USER", data);
            resolve("");
            break;
          }
          default:
            reject();
            break;
        }
      });
    }
  },
  getters: {
    getLogado(state) {
      return state.logado;
    },
    getDesativado(state) {
      return state.user.desativado;
    },
    get_usuario(state) {
      return state.user.usuario;
    },
    get_funcionario(state) {
      return state.funcionario;
    },
    getNome(state) {
      return state.user.nome;
    },
    getFotoPerfil(state) {
      return state.user.foto_perfil;
    },
    getTipo(state) {
      return state.user.tipo;
    },
    getToken(state) {
      return state.token;
    },
    getId(state) {
      return state.user.id;
    },
    getNotificaSolicitacao(state) {
      return state.user.notifica_solicitacao;
    },
    getUserloggedInfo(state) {
      return state.user;
    },
    getIdParceiro(state) {
      return state.funcionario.parceiro_id_fk;
    }
  }
});

//Se o usuário estiver logado abre um canal
if (store.getters.getToken != null) {
  Vue.use(VueSocketIO, socketInstance({ token: store.getters.getToken }), {
    store, // vuex store instance
    actionPrefix: "SOCKET_", // keep prefix in uppercase
    eventToActionTransformer: actionName => actionName // cancel camel case
  });
}

export default store;
